import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment, Create, Close } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import NavPills from 'components/NavPills/NavPills.js';

import SellGroup from './SellGroup';
import BonificationGroup from './BonificationGroup';
import GridContainer from 'components/Grid/GridContainer';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';

//confirm delete
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
}));

export default function Groups(props) {
  const classes = useStyles();

  const { promotion, rule, showNotify, reloadPromo } = props;

  //#region  confirma al eliminar
  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirmDeleteGroup(funtionDelete) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de eliminar?"
        onConfirm={() => {
          funtionDelete();
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Esta acción eliminará los productos que estén involucrados
      </SweetAlert>,
    );
  }
  //#endregion

  return (
    <GridItem xs={12}>
      {alert}
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Grupos de venta / Bonificación</h4>
        </CardHeader>
        <CardBody>
          {promotion.bonification_type === 'P' ? (
            <NavPills
              color="primary"
              tabs={[
                {
                  tabButton: 'Venta',
                  tabContent: (
                    <SellGroup
                      promotion={promotion}
                      rule={rule}
                      showNotify={showNotify}
                      reloadPromo={reloadPromo} //x
                      setCurrentSellGroup={props.setCurrentSellGroup}
                      confirmDeleteGroup={confirmDeleteGroup}
                    />
                  ),
                },
                {
                  tabButton: 'Bonificación',
                  tabContent: (
                    <BonificationGroup
                      promotion={promotion}
                      rule={rule}
                      showNotify={showNotify}
                      reloadPromo={reloadPromo} //x
                      setCurrentBoniGroup={props.setCurrentBoniGroup}
                      confirmDeleteGroup={confirmDeleteGroup}
                    />
                  ),
                },
              ]}
            />
          ) : (
            <NavPills
              color="primary"
              tabs={[
                {
                  tabButton: 'Venta',
                  tabContent: (
                    <SellGroup
                      promotion={promotion}
                      rule={rule}
                      showNotify={showNotify}
                      reloadPromo={reloadPromo} //x
                      setCurrentSellGroup={props.setCurrentSellGroup}
                      confirmDeleteGroup={confirmDeleteGroup}
                    />
                  ),
                },
              ]}
            />
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
}
